

class Geo {

    constructor(value, GeoType = 'wgs') {
    }

} 

export default Geo;